module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.nachricht.show),
      callback: function($$v) {
        _vm.$set(_vm.nachricht, "show", $$v)
      },
      expression: "nachricht.show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    class: _vm.nachricht.typ === 'error' ? 'orange darken-3 white--text' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.nachricht.titel ? _vm.nachricht.titel : 'Meldung') + "\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.nachricht.nachricht) ? _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.nachricht.nachricht) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.nachricht.error) ? _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.nachricht.error) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3df772a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogNachricht.vue
// module id = 820
// module chunks = 15